import { render, staticRenderFns } from "./CustomFieldsCrudList.vue?vue&type=template&id=76492f7c&"
import script from "./CustomFieldsCrudList.vue?vue&type=script&lang=js&"
export * from "./CustomFieldsCrudList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports